import { render, staticRenderFns } from "./loading-mask.component.vue?vue&type=template&id=408e4644&scoped=true"
import script from "./loading-mask.component.vue?vue&type=script&lang=ts"
export * from "./loading-mask.component.vue?vue&type=script&lang=ts"
import style0 from "./loading-mask.component.vue?vue&type=style&index=0&id=408e4644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408e4644",
  null
  
)

export default component.exports